module.exports = __webpack_public_path__ + "static/media/Florida Academy of Physician Assistants logo.8fb54bf9.jpeg";